<template>
  <b-modal
    ref="modal"
    title="Adicionar Instituição"
    ok-title="Salvar"
    cancel-title="Cancelar"
    centered
    @ok.prevent="handleOk"
  >
    <b-form @submit.prevent="handleOk">
      <b-form-group
        label="Nome da Instituição"
        label-for="input-manager"
        :state="validationState.manager"
        invalid-feedback="Preencha o nome da instituição"
      >
        <b-form-input
          id="input-manager"
          v-model.trim="institutionData.manager"
          :state="validationState.manager"
          placeholder="Digite o nome da instituição"
          required
          @keyup.enter="handleOk"
        />
      </b-form-group>

      <b-form-group
        label="Website da Instituição"
        label-for="input-website"
        :state="validationState.website_url"
        invalid-feedback="Preencha o website corretamente"
      >
        <b-form-input
          id="input-website"
          v-model.trim="institutionData.website_url"
          :state="validationState.website_url"
          type="url"
          placeholder="https://site.com"
          required
        />
      </b-form-group>

      <b-form-group
        label="Tipo de Fundo"
        label-for="select-category"
        :state="validationState.fund_type"
        invalid-feedback="Selecione o tipo de fundo"
      >
        <b-form-select
          id="select-category"
          v-model="institutionData.fund_type"
          :options="fundTypeOptions"
          placeholder="Selecione o tipo de fundo"
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";

export default {
  name: "AddDocumentModal",
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
  },
  data() {
    return {
      institutionData: {
        manager: "",
        website_url: "",
        fund_type: null,
      },
      validationState: {
        manager: null,
        website_url: null,
        fund_type: null,
      },
      fundTypeOptions: [
        { value: "Fundos de Ações", text: "Fundos de Ações" },
        { value: "Fundo Multimercado", text: "Fundo Multimercado" },
        { value: "Fundo Crédito", text: "Fundo Crédito" },
      ],
    };
  },

  methods: {
    show() {
      this.resetForm();
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    resetForm() {
      this.institutionData = {
        manager: "",
        website_url: "",
        fund_type: null,
      };
      this.validationState = {
        manager: null,
        website_url: null,
        fund_type: null,
      };
    },

    validURL(url) {
      try {
        new URL(url);
        return true;
      } catch (_) {
        return false;
      }
    },
    handleOk(event) {
      const { manager, website_url, fund_type } = this.institutionData;

      const isManagerValid = !!manager;
      const isWebsiteValid = !!website_url && this.validURL(website_url);
      const isFundTypeValid = !!fund_type;

      this.validationState.manager = isManagerValid;
      this.validationState.website_url = isWebsiteValid;
      this.validationState.fund_type = isFundTypeValid;

      if (!isManagerValid || !isWebsiteValid || !isFundTypeValid) {
        return;
      }

      this.$emit("save-document", { manager, website_url, fund_type });
      this.hide();
    },
  },
};
</script>
